module.exports = __webpack_public_path__ + "img/rule-wrapper.d468b493.png";